import React, { useEffect, useRef, useState } from "react";
import BimatterViewer from "bimatter-viewer";
import config from "../../config";
import {
    initViewer,
    setModel,
} from "../../app/features/viewer/viewerMainSlice";
import {
    useAppDispatch,
    useAppSelector,
    useViewer,
} from "../../app/hooks/hooks";
import { keyEv } from "./ViewerKeyBoardEvents/ViewerKeyBoardEvents";
import ViewerButtons from "./ViewerButtons/ViewerButtons";
import { useGetStructureMutation } from "../../app/services/params/params";
import {
    selectViewerPropsVisibility,
    selectViewerTreeVisibility,
    toggleViewerTreeVisibility,
} from "../../app/features/viewer/buttonsSlice/buttonsSlice";
import ViewerProps from "./ViewerProps/ViewerProps";
import classes from "./Viewer.module.css";
import ViewerTree, { Chunk } from "./ViewerTree/ViewerTree";
import ViewerContextMenu from "./ViewerContextMenu/ViewerContextMenu";
import BimatterLoader from "../Loaders/BimatterLoader";
import ViewerProgressBar from "./ViewerProgressBar/ViewerProgressBar";
import {
    BufferAttribute,
    BufferGeometry,
    Color,
    DoubleSide,
    Group,
    Material,
    Matrix4,
    Mesh,
    MeshLambertMaterial,
} from "three";
import { useNavigate } from "react-router-dom";

import { setAlert } from "../../app/features/alertSlice/alertSlice";
interface ViewerProps {
    model_paths: string[];
}
function Viewer({ model_paths }: ViewerProps) {
    const dispatch = useAppDispatch();
    const viewerTreeVisibility = useAppSelector(selectViewerTreeVisibility);
    const viewerPropsVisibility = useAppSelector(selectViewerPropsVisibility);
    const ref = useRef(null);
    const [curTree, setCurTree] = useState<{ [modelID: number]: Chunk } | null>(
        null
    );
    const [progress, setProgress] = useState<number | null>(null);

    const offset = 6;
    const defWifth = 400;
    //1123
    const defaultWidth = {
        props: !viewerPropsVisibility ? offset : defWifth,
        tree: !viewerTreeVisibility ? offset : defWifth + offset * 2,
    };
    const navigate = useNavigate();
    // const [width, setWidth] = useState(defaultWidth);
    const [viewerOnFocuse, setViewerOnFocuse] = useState(true);
    const [loading, setLoading] = useState(true);
    const [getStructure] = useGetStructureMutation();
    // const setPropsWidth = (propsWidth: number) => {
    //     setWidth((ex) => {
    //         return { ...ex, props: propsWidth };
    //     });
    // };
    // const setTreeWidth = (treeWidth: number) => {
    //     setWidth((ex) => {
    //         return { ...ex, tree: treeWidth };
    //     });
    // };
    const mouseOn = () => {
        setViewerOnFocuse(true);
    };
    const mouseOut = () => {
        setViewerOnFocuse(false);
    };
    useEffect(() => {
        const viewer = new BimatterViewer({
            container: ref.current!,
            useDefaultTexture: false,
        });
        viewer.selector.selection.selectionCallback = () => {
            viewer.context.controls.setOrbitByClick();
        };
        viewer.context.renderer.threeRenderer.setClearColor(0x000000, 0);
        viewer.utils.propsUtils.useDefaultGetPropertiesById = false;

        viewer.utils.navigationCubeUtil.active = true;
        // if (!viewerTreeVisibility) return;
        // viewer.container.dispatchEvent(new CustomEvent("selectionTrigger"));
        // const model_path = "ar.min.bmt";

        const curKeyEv = (e: KeyboardEvent) => keyEv(e, viewer);
        loadModelWithWorker(viewer);
        document.addEventListener("keydown", curKeyEv);

        // for (const model_path of model_paths) {
        //     viewer
        //         .loadModel(`${config.SERVER}/FileSystem/${model_path}`, true)
        //         .then((model) => {
        //             if (!model) return;
        //             document.addEventListener("keydown", curKeyEv);
        //             viewer.container.addEventListener("mouseenter", mouseOn);
        //             viewer.container.addEventListener("mouseleave", mouseOut);
        //             setLoading(false);
        //             dispatch(
        //                 setModel({
        //                     modelID: model.modelID,
        //                     model_id: model_path,
        //                 })
        //             );

        //             getStructure(model.modelID)
        //                 .unwrap()
        //                 .then((structure) => {
        //                     model.properties.setStructure(structure);
        //                     setCurTree((ex) => {
        //                         if (!ex) {
        //                             return { [model.modelID]: structure };
        //                         }
        //                         return {
        //                             ...ex,
        //                             [model.modelID]: structure,
        //                         };
        //                     });
        //                 });
        //             dispatch(toggleViewerTreeVisibility());
        //         });
        // }
        //@ts-ignore
        window.viewer = viewer;
        dispatch(
            initViewer(() => {
                return viewer;
            })
        );
        return () => {
            document.removeEventListener("keydown", curKeyEv);
            if (viewer) {
                viewer.container.removeEventListener("mouseenter", mouseOn);
                viewer.container.removeEventListener("mouseleave", mouseOut);
                viewer.container.remove();
                viewer.utils.navigationCubeUtil.cubeContainer?.remove();
                // viewer.dispose()
                console.log("need to dispose viewer");
            }
        };
    }, []);
    const loadModelWithWorker = async (viewer: BimatterViewer) => {
        if (!viewer) return;
        const materialDict: { [key: string]: Material } = {};
        let modelsLoaded = 0;
        for (const model_path of model_paths) {
            // if (file.file.name.endsWith(".ifc")) {
            //     const ifcModel = await viewer.loadModel(`${config.SERVER}/FileSystem/${model_path}`, true);
            //     dispatch(
            //         setModel({
            //             modelID: ifcModel!.modelID,
            //             name: file.name,
            //             path: file.path,
            //         })
            //     );
            //     return;
            // }

            applyWorker(viewer, model_path).then(() => {
                if (modelsLoaded === model_paths.length) {
                    try {
                        viewer.models[modelsLoaded - 1].fitToView();
                    } catch {}
                }
            });

            // if (Object.keys(viewer.models).length) {
            //     applyWorker(viewer, file);
            // } else {
            //     applyWorker(viewer, file);
            // }
        }
        // if(file.file.name)
        function applyWorker(viewer: BimatterViewer, model_path: string) {
            return new Promise((resolve) => {
                const worker = new Worker(
                    new URL("./Workers/bmtLoaderWorker.js", import.meta.url),
                    {
                        type: "module",
                    }
                );
                const curModelId =
                    (Math.max(
                        ...Object.keys(viewer.models).map((n) => Number(n))
                    ) +
                        1) |
                    0;
                const model = viewer.addEmptyModel(curModelId);
                const selectGroup = new Group();
                const preselectGroup = new Group();
                worker.onmessage = (data) => {
                    if (data.data.error) {
                        dispatch(
                            setAlert({
                                message:  "Error 01 while loading model, please send this code to Developer",
                                type: "error",
                            })
                        );
                        
                        navigate("/files");
                        return;
                    } else if (data.data.ready) {
                        console.log("ready");
                        viewer.selector.selectorModels[model.modelID] =
                            model.threeGeometry.children;
                        viewer.selector.selection._selectedMesh.add(
                            selectGroup
                        );

                        viewer.selector.preSelection._preSelectMesh.add(
                            preselectGroup
                        );
                        viewer.selector.selectedElements[model.modelID] =
                            new Set();
                        if (data.data.state && data.data.defaultState) {
                            model.setState(
                                data.data.state,
                                data.data.defaultState
                            );
                        }
                        modelsLoaded++;
                        dispatch(
                            setModel({
                                modelID: model.modelID,
                                model_id: model_path,
                            })
                        );
                        getStructure(model.modelID)
                            .unwrap()
                            .then((structure) => {
                                model.properties.setStructure(structure);
                                setCurTree((ex) => {
                                    if (!ex) {
                                        return { [model.modelID]: structure };
                                    }
                                    return {
                                        ...ex,
                                        [model.modelID]: structure,
                                    };
                                });
                                worker.postMessage({
                                    type: "state",
                                    data: model.threeGeometry.children.map(
                                        (child) => ({
                                            index: (child as Mesh).geometry
                                                .index?.array,
                                            ids: (child as Mesh).geometry
                                                .attributes.ids.array,
                                            matInd: child.name,
                                        })
                                    ),
                                });
                            });
                    } else if (data.data.state) {
                        model.setState(
                            data.data.state,
                            data.data.defaultState,
                            data.data.activeElements
                        );
                        resolve(model);
                        setProgress(null);
                        worker.terminate();
                    } else if (data.data.setMatrix) {
                        const matrixArr = JSON.parse(data.data.setMatrix);
                        const matrix = new Matrix4()
                            .fromArray(matrixArr)
                            .invert();
                        if (!viewer.loaders.coordinationMatrix) {
                            viewer.loaders.coordinationMatrix = matrix
                                .clone()
                                .invert();
                        }
                    } else if (data.data.process) {
                        if (loading) setLoading(false);
                        const process = data.data.process;
                        const persent = Math.round(
                            (process.current * 100) / process.total
                        );
                        setProgress(persent);
                        // progress.innerHTML = !process.total
                        //     ? process.type
                        //     : `${process.type} ${persent}%`;
                    } else {
                        const start = Date.now();
                        const geomData = data.data.geom;
                        const geom = new BufferGeometry();
                        geom.setAttribute(
                            "position",
                            new BufferAttribute(geomData.pos, 3)
                        );
                        geom.setAttribute(
                            "ids",
                            new BufferAttribute(geomData.ids, 1)
                        );
                        geom.setAttribute(
                            "normal",
                            new BufferAttribute(geomData.normal, 3)
                        );
                        geom.setIndex(
                            new BufferAttribute(
                                new Uint32Array(geomData.ind),
                                1
                            )
                        );

                        // geom.computeVertexNormals();
                        const a = data.data.material.a;
                        const color = data.data.material.color;
                        let material =
                            materialDict[
                                `${curModelId}_${data.data.material.color.toString()}_${a}`
                            ];
                        if (!material) {
                            material = new MeshLambertMaterial({
                                color: new Color(
                                    ...(color instanceof Array
                                        ? color
                                        : [color])
                                ),
                                opacity: a,
                                transparent: a !== 1,
                                side: DoubleSide,
                            });
                            materialDict[
                                `${curModelId}_${data.data.material.color.toString()}_${a}`
                            ] = material;
                        }
                        const mesh = new Mesh(geom, material);

                        if (
                            Object.keys(viewer.models).length &&
                            viewer.loaders.coordinationMatrix
                        ) {
                            const matrixArr = JSON.parse(data.data.matrix);
                            const matrix = new Matrix4()
                                .fromArray(matrixArr)
                                .invert();
                            geom.applyMatrix4(matrix);
                            geom.applyMatrix4(
                                viewer.loaders.coordinationMatrix
                            );
                        }

                        // geom.computeVertexNormals();
                        geom.computeBoundingBox();

                        geom.computeBoundingSphere();

                        mesh.name = data.data.name.toString();

                        // viewer.bvhManager.useWorker = new Worker(
                        //     new URL("./Workers/bvhWorker.js", import.meta.url),
                        //     {
                        //         type: "module",
                        //     }
                        // );
                        model.addMeshToModel(
                            mesh,
                            selectGroup,
                            preselectGroup,
                            model.threeGeometry.children.length === 1
                        );
                    }
                    // console.log(data);
                };
                // worker.postMessage("./Models/model.ifc");
                worker.postMessage({
                    type: "load",
                    data: `${config.SERVER}/${model_path}`,
                });
            });
        }
    };
    // useEffect(() => {
    //     setTreeWidth(defaultWidth.tree);
    // }, [viewerTreeVisibility]);
    return (
        <ViewerContextMenu enable={viewerOnFocuse}>
            <BimatterLoader loading={loading}></BimatterLoader>
            {progress ? (
                <ViewerProgressBar progress={progress}></ViewerProgressBar>
            ) : (
                <></>
            )}
            <ViewerButtons></ViewerButtons>
            {viewerTreeVisibility ? (
                curTree ? (
                    <ViewerTree tree={structuredClone(curTree)} />
                ) : (
                    <></>
                )
            ) : (
                <></>
            )}

            <div className={classes.viewerBackground}></div>
            <div
                ref={ref}
                className={classes.viewerContainer}
                onMouseEnter={mouseOn}
                onMouseLeave={mouseOut}
            />

            {viewerPropsVisibility ? <ViewerProps></ViewerProps> : <></>}
        </ViewerContextMenu>
    );
}

export default Viewer;
